window.actionEvents = {
    'click .action-show': function(e, value, row) {
        e.preventDefault();
        let table_id = this.$el_.attr('id');
        let actions = tables[table_id].actions;
        if (typeof actions.show.route !== "undefined") {
            window.location.href = route(actions.show.route, {
                id: row.id
            });
        } else if (typeof actions.show.url !== "undefined") {
            window.location.href = actions.show.url + '/' + row.id;
        }
    },
    'click .action-edit': function(e, value, row) {
        e.preventDefault();
        let table_id = this.$el_.attr('id');
        let actions = tables[table_id].actions;
        if (typeof actions.edit.route !== "undefined") {
            window.location.href = route(actions.edit.route, {
                id: row.id
            });
        } else if (typeof actions.edit.url !== "undefined") {
            window.location.href = actions.edit.url + '/' + row.id;
        }
    },
    'click .action-destroy': function(e, value, row, index) {
        e.preventDefault();
        let _token = $('input[name=_token]').val();
        let id = this.data[index].id;
        let table_id = this.$el_.attr('id');
        let actions = tables[table_id].actions;
        bootbox.confirm({
            title: actions.destroy.title,
            message: actions.destroy.message,
            buttons: {
                cancel: {
                    label: 'No',
                    className: 'btn-outline-primary'
                },
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                }
            },
            callback: function (result) {
                if (result === false) {
                    return;
                }
                let url = '';
                if (typeof actions.destroy.route !== "undefined") {
                    url = route(actions.destroy.route, {
                        id: row.id
                    });
                } else if (typeof actions.destroy.url !== "undefined") {
                    url = actions.destroy.url + '/' + id;
                }
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: {
                        '_method': 'DELETE',
                        '_token': _token,
                    },
                    success: function (response) {
                        switch (response.status) {
                            case 'ERROR':
                                Swal.fire({
                                    icon: 'error',
                                    title: response.message,
                                    showConfirmButton: true,
                                    customClass: {
                                        confirmButton: 'bg-info'
                                    }
                                });
                                break;
                            case 'OK':
                                $('#'+table_id).bootstrapTable('refresh');
                                Swal.fire({
                                    icon: 'success',
                                    title: response.message,
                                    showConfirmButton: false,
                                    timer: 3000
                                });
                                break;
                        }
                    },
                });
            }
        });
        $('.modal-header').addClass('alert-danger');
    }
};
